import { ORDERS_SECTION } from '../../../constants/strings';

export const getDuplicateBasketItemError = error =>
  error?.errorCode === 'basketLimitExceeded'
    ? error.message
    : ORDERS_SECTION.NOTIFICATIONS.DUPLICATE_ORDER_ERROR;
